export const apiUrl = "https://app-api-pod-prd.azurewebsites.net/api/";

//export const apiUrl = "https://app-api-pod-qas.azurewebsites.net/api";